/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Injectable, inject} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {FormFieldAttribute} from '../../../../../../models/FormCategory';
import {CustomValidators} from '../../../../../../validators/validators';

@Injectable({
  providedIn: 'root',
})
export class GenericFormBuilderService {
  private readonly fb = inject(FormBuilder);

  createSimpleControl(attribute: FormFieldAttribute): FormControl {
    const validators = this.buildValidators(attribute);

    return this.fb.control(
      {
        value: this.getDefaultValue(attribute),
        disabled: attribute.isDisabled || false,
      },
      validators,
    );
  }

  private getDefaultValue(
    attribute: FormFieldAttribute,
  ): boolean | string | null {
    switch (attribute.type) {
      case 'number':
        return '';
      case 'date':
        return null;
      case 'select':
        return '';
      case 'boolean':
        return false;
      default:
        return '';
    }
  }

  buildValidators(attribute: FormFieldAttribute): ValidatorFn[] {
    const validators: ValidatorFn[] = [];
    if (attribute.min !== undefined) {
      validators.push(
        attribute.type === 'number'
          ? Validators.min(attribute.min)
          : Validators.minLength(attribute.min),
      );
    }

    if (attribute.max !== undefined) {
      validators.push(
        attribute.type === 'number'
          ? Validators.max(attribute.max)
          : Validators.maxLength(attribute.max),
      );
    }

    if (attribute.type === 'email') {
      validators.push(Validators.email);
    }

    if (attribute.type === 'document') {
      validators.push(CustomValidators.urlValidator());
    }

    if (attribute.digits !== undefined) {
      validators.push(CustomValidators.stepValidator(attribute.digits));
    }

    return validators;
  }
}
